import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(seleccionarHerramientaMostrar),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(seleccionarHerramientaEliminarTodo),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(seleccionarHerramientaReloj),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(seleccionarHerramientaGrupoGeneral);

import { put, select, call } from 'redux-saga/effects';
import { getPantalla, barraHerramientasSelectors, relojSelectors } from '../../selectors';
import { PANTALLA_VENTANA_ID } from '../../constantes';
import { eliminarTextos } from './grupo-texto'; // pizarra

import { HERRAMIENTA_ELIMINAR_DIBUJO } from '../../pizarra/constantes';
import { seleccionarHerramienta as seleccionarHerramientaPizarra, notificarCambios } from '../../pizarra/actions';
import { mostrarImagenUsuario, ocultarImagenUsuario, seleccionarHerramienta, mostrarReloj, ocultarReloj } from '../../actions';
import { mostrarTextosUsuario, ocultarTextosUsuario } from '../../texto-usuario/actions';
import { getTextosUsuarioVisible, getImagenUsuarioVisible } from '../../selectors';
import { MOSTRAR_ID, PUNTERO_ID, RELOJ_ID, ELIMINAR_TODO_ID, GRUPO_PIZARRA } from '../../herramientas/constantes';
import * as Util from '../../util';

function seleccionarHerramientaMostrar(action) {
  var textosUsuarioVisible, imagenUsuarioVisible, mostrarActivo;
  return _regeneratorRuntime.wrap(function seleccionarHerramientaMostrar$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getTextosUsuarioVisible);

        case 2:
          textosUsuarioVisible = _context.sent;
          _context.next = 5;
          return select(getImagenUsuarioVisible);

        case 5:
          imagenUsuarioVisible = _context.sent;
          mostrarActivo = !textosUsuarioVisible && !imagenUsuarioVisible; // if (action.valor) {

          if (mostrarActivo) {
            _context.next = 14;
            break;
          }

          _context.next = 10;
          return put(ocultarImagenUsuario());

        case 10:
          _context.next = 12;
          return put(ocultarTextosUsuario());

        case 12:
          _context.next = 18;
          break;

        case 14:
          _context.next = 16;
          return put(mostrarImagenUsuario());

        case 16:
          _context.next = 18;
          return put(mostrarTextosUsuario());

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function seleccionarHerramientaEliminarTodo() {
  return _regeneratorRuntime.wrap(function seleccionarHerramientaEliminarTodo$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return call(eliminarTextos);

        case 2:
          _context2.next = 4;
          return put(seleccionarHerramientaPizarra(HERRAMIENTA_ELIMINAR_DIBUJO));

        case 4:
          _context2.next = 6;
          return put(notificarCambios(null));

        case 6:
          _context2.next = 8;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 8:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function seleccionarHerramientaReloj() {
  var relojVisible;
  return _regeneratorRuntime.wrap(function seleccionarHerramientaReloj$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(relojSelectors.getVisible);

        case 2:
          relojVisible = _context3.sent;

          if (!relojVisible) {
            _context3.next = 8;
            break;
          }

          _context3.next = 6;
          return put(ocultarReloj());

        case 6:
          _context3.next = 10;
          break;

        case 8:
          _context3.next = 10;
          return put(mostrarReloj());

        case 10:
          _context3.next = 12;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 12:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

export function seleccionarHerramientaGrupoGeneral(action) {
  var pantallaId, boton, mensaje;
  return _regeneratorRuntime.wrap(function seleccionarHerramientaGrupoGeneral$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.t0 = action.herramientaId;
          _context4.next = _context4.t0 === MOSTRAR_ID ? 3 : _context4.t0 === ELIMINAR_TODO_ID ? 6 : _context4.t0 === RELOJ_ID ? 17 : 20;
          break;

        case 3:
          _context4.next = 5;
          return call(seleccionarHerramientaMostrar, action);

        case 5:
          return _context4.abrupt('break', 20);

        case 6:
          _context4.next = 8;
          return select(getPantalla);

        case 8:
          pantallaId = _context4.sent;
          _context4.next = 11;
          return select(barraHerramientasSelectors.getBoton, action.herramientaId);

        case 11:
          boton = _context4.sent;
          mensaje = pantallaId === PANTALLA_VENTANA_ID ? boton.mensajeVentana || boton.mensaje : boton.mensaje;

          if (!Util.confirm(mensaje)) {
            _context4.next = 16;
            break;
          }

          _context4.next = 16;
          return call(seleccionarHerramientaEliminarTodo);

        case 16:
          return _context4.abrupt('break', 20);

        case 17:
          _context4.next = 19;
          return call(seleccionarHerramientaReloj);

        case 19:
          return _context4.abrupt('break', 20);

        case 20:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}